import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=ff18bbb0"
import script from "./shouye.vue?vue&type=script&lang=js"
export * from "./shouye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports